import handleCRUD from 'Helper/API/handleCRUD'

function adminDisplayReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'CLEAR_VISITHISTORY_WIDGET':
      return {
        ...state,
        visitHistoryWindow: null
      }
    case 'INIT_VISITHISTORY_WIDGET':
      return {
        ...state,
        visitHistoryWindow: {}
      }
    case 'CLEAR_PRESCRIPTIONPANELS_WIDGET':
      return {
        ...state,
        prescriptionPanelsWindow: null
      }
    case 'INIT_PRESCRIPTIONPANELS_WIDGET':
      return {
        ...state,
        prescriptionPanelsWindow: {}
      }
    case 'CLEAR_APILOG_WIDGET':
      return {
        ...state,
        apiLogWindow: null
      }
    case 'INIT_APILOG_WIDGET':
      return {
        ...state,
        apiLogWindow: {}
      }
    case 'CLEAR_CLICKLOG_WINDOW':
      return {
        ...state,
        clickLogWindow: null
      }
    case 'INIT_CLICKLOG_WINDOW':
      return {
        ...state,
        clickLogWindow: {}
      }
    case 'CLEAR_BACKUPS_WIDGET':
      return {
        ...state,
        backupsWindow: null
      }
    case 'INIT_BACKUPS_WIDGET':
      return {
        ...state,
        backupsWindow: {}
      }
    case 'CLEAR_ENTDILUTIONS_WIDGET':
      return {
        ...state,
        entDilutionsWindow: null
      }
    case 'INIT_ENTDILUTIONS_WIDGET':
      return {
        ...state,
        entDilutionsWindow: {}
      }
    case 'CLEAR_CLINIC_WIDGET':
      return {
        ...state,
        clinicWindow: null
      }
    case 'INIT_CLINIC_WIDGET':
      return {
        ...state,
        clinicWindow: {}
      }
    case 'CLEAR_PHARMACYPROFILES_WIDGET':
      return {
        ...state,
        pharmacyProfilesWindow: null
      }
    case 'INIT_PHARMACYPROFILES_WIDGET':
      return {
        ...state,
        pharmacyProfilesWindow: {}
      }
    case 'CLEAR_PHARMACYEXTRACTS_WIDGET':
      return {
        ...state,
        pharmacyExtractsWindow: null
      }
    case 'INIT_PHARMACYEXTRACTS_WIDGET':
      return {
        ...state,
        pharmacyExtractsWindow: {}
      }
    case 'CLEAR_PROTOCOLS_WIDGET':
      return {
        ...state,
        protocolsWindow: null
      }
    case 'INIT_PROTOCOLS_WIDGET':
      return {
        ...state,
        protocolsWindow: {}
      }
    case 'CLEAR_SKINTESTDETAIL_WIDGET':
      return {
        ...state,
        skinTestDetailWindow: null
      }
    case 'INIT_SKINTESTDETAIL_WIDGET':
      return {
        ...state,
        skinTestDetailWindow: {}
      }
    case 'CLEAR_PANELS_WIDGET':
      return {
        ...state,
        panelsWindow: null
      }
    case 'INIT_PANELS_WIDGET':
      return {
        ...state,
        panelsWindow: {}
      }
    case 'CLEAR_ADMIN_DISPLAY':
      // return default state
      return { }
    case 'INIT_EXTRACTS_WINDOW':
      return {
        ...state,
        extractsWindow: {}
      }
    case 'CLEAR_EXTRACTS_WINDOW':
      return {
        ...state,
        extractsWindow: null
      }
    case 'INIT_PROFILE_WINDOW':
      return {
        ...state,
        profileWindow: {}
      }
    case 'CLEAR_PROFILE_WINDOW':
      return {
        ...state,
        profileWindow: null
      }
    case 'INIT_INVENTORY_WINDOW':
      return {
        ...state,
        inventoryWindow: {}
      }
    case 'CLEAR_INVENTORY_WINDOW':
      return {
        ...state,
        inventoryWindow: null
      }
    case 'INIT_MESSAGING_WINDOW':
      return {
        ...state,
        messagingWindow: {}
      }
    case 'CLEAR_MESSAGING_WINDOW':
      return {
        ...state,
        messagingWindow: null
      }

    case 'STORE_MESSAGE_READ':
    case 'STORE_MESSAGE_READ_ALL':
    case 'STORE_MESSAGE_SEARCH':
    case 'STORE_MESSAGE_CREATE':
    case 'STORE_MESSAGE_UPDATE':
    case 'STORE_MESSAGE_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'message_id',
          ['messagingWindow'],
          'messages'
        )
      }
    case 'STORE_EXTRACT_READ':
    case 'STORE_EXTRACT_READ_ALL':
    case 'STORE_EXTRACT_SEARCH':
    case 'STORE_EXTRACT_CREATE':
    case 'STORE_EXTRACT_UPDATE':
    case 'STORE_EXTRACT_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'extract_id',
          ['extractsWindow', 'profileWindow'],
          'extracts'
        )
      }
    case 'STORE_PROVIDER_READ':
    case 'STORE_PROVIDER_READ_ALL':
    case 'STORE_PROVIDER_SEARCH':
    case 'STORE_PROVIDER_CREATE':
    case 'STORE_PROVIDER_UPDATE':
    case 'STORE_PROVIDER_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'provider_id',
          ['profileWindow'],
          'providers'
        )
      }
    case 'STORE_PROFILE_READ':
    case 'STORE_PROFILE_READ_ALL':
    case 'STORE_PROFILE_SEARCH':
    case 'STORE_PROFILE_CREATE':
    case 'STORE_PROFILE_UPDATE':
    case 'STORE_PROFILE_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'profile_id',
          ['profileWindow'],
          'profiles'
        )
      }
    case 'STORE_INVENTORY_READ':
    case 'STORE_INVENTORY_READ_ALL':
    case 'STORE_INVENTORY_SEARCH':
    case 'STORE_INVENTORY_CREATE':
    case 'STORE_INVENTORY_UPDATE':
    case 'STORE_INVENTORY_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'inventory_id',
          ['inventoryWindow', 'extractsWindow'],
          'inventory'
        )
      }
    case 'STORE_BACKUP_READ':
    case 'STORE_BACKUP_READ_ALL':
    case 'STORE_BACKUP_SEARCH':
    case 'STORE_BACKUP_CREATE':
    case 'STORE_BACKUP_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'backup_id',
          ['backupsWindow'],
          'backups'
        )
      }
    default:
      return state
  }
}

export default adminDisplayReducer

const handleWindowCRUD = (
  action,
  state,
  idName,
  windows = [],
  property = ''
) => {
  // Note, although this function accepts state, it does not modify it,
  // only returns what should be merged into state
  const newWindows = {}
  windows.forEach(window => {
    let lastWindow = state[window] != null ? { ...state[window] } : null
    if (window === 'patientDetails' && lastWindow == null) {
      // this is a special case, patientDetails should always be listening for data
      // whenever we are on the patient screen
      lastWindow = {}
    }
    const newWindowData = lastWindow != null ? { ...lastWindow } : null
    if (lastWindow != null) {
      // if the window hasn't been initialized, we shouldn't change it.
      const lastWindowProperty = lastWindow[property] || []
      newWindowData[property] = handleCRUD(action, lastWindowProperty, idName)
    }
    newWindows[window] = lastWindow != null ? { ...newWindowData } : null
  })
  return newWindows
}
